import React from "react";

import { DateFormat, formatCurrency, formatDate } from "../../utils";
import {
  BROKERAGE_ACCOUNT_FALLBACK,
  TRANSFER_COUNTERPARTY_FALLBACK,
} from "./constants";
import { CashTransferDeleteTextProps } from "./types";

// The sentence the Activity feed's transfer deletion confirms with, kept beside
// its fallbacks so the wording and the names it falls back to move together.
export const CashTransferDeleteText: React.FC<CashTransferDeleteTextProps> = ({
  amountEur,
  date,
  investmentName,
  counterpartyAccountName,
}) => (
  <>
    Do you really want to delete the cash transfer of{" "}
    <strong>{formatCurrency(Math.abs(amountEur))}</strong> on{" "}
    <strong>{formatDate(date, DateFormat.DMY_SPACE)}</strong> between{" "}
    <strong>{investmentName ?? BROKERAGE_ACCOUNT_FALLBACK}</strong> and{" "}
    <strong>{counterpartyAccountName ?? TRANSFER_COUNTERPARTY_FALLBACK}</strong>
    ?
  </>
);
